<div id="toastBase" *ngIf="!!toastList?.length" class="{{ toastSetts.xPos }} {{ toastSetts.yPos }}">
    
    <div *ngFor="let toast of toastList" class="upar-toast {{ toast.type }}" (click)="removeToast(toast.utid)">
        <h6>{{ 'toast.'+ toast.type | translate }}</h6>
        <p>{{ toast.description | translate }}</p>
    </div>

</div>